import script from "./SaleScanner.vue?vue&type=script&setup=true&lang=js"
export * from "./SaleScanner.vue?vue&type=script&setup=true&lang=js"

import "./SaleScanner.vue?vue&type=style&index=0&id=7df8bb86&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7df8bb86"]])

export default __exports__